/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)

import VueSuggestion from 'vue-suggestion'
Vue.use(VueSuggestion)

// Draggable
import draggable from 'vuedraggable'
Vue.component('draggable', draggable);

import Select2 from 'v-select2-component';
Vue.component('Select2', Select2);

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
Vue.component('vue-cropper', VueCropper);

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
Vue.component('flatPickr', flatPickr);

import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
Vue.component('VueTimepicker', VueTimepicker);

import 'jodit/build/jodit.min.css'
import Vue from 'vue'
import JoditVue from 'jodit-vue'
Vue.use(JoditVue)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import vueCountryRegionSelect from 'vue-country-region-select'
Vue.use(vueCountryRegionSelect)

// import Datepicker from 'vuejs-datepicker';
// Vue.component('Datepicker', Datepicker);

// Vee Validate
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

// No message specified.
extend('email', email);

// Override the default message.
extend('required', {
    ...required,
    message: 'This field is required'
});
// Override the default message.
extend('email', {
    ...email,
    message: 'Please use a valid email address'
});
extend('requiredArray', {
    validate (value) {
        return !_.isEmpty(value)
    },
    message: 'This field is required',
    computesRequired: true
});
// Register it globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
// End of Vee Validate Stuff

Vue.use(require('vue-moment'));

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.config.devtools = true;
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('flash-alert', require('./components/FlashAlert.vue').default);
Vue.component('error-message', require('./components/ErrorMessage.vue').default);
Vue.component('error-message-judge', require('./components/ErrorMessageJudge.vue').default);
Vue.component('order-form', require('./components/OrderForm.vue').default);
Vue.component('order-form-next-prev-admin', require('./components/OrderFormNextPrevAdmin.vue').default);
Vue.component('order-delete', require('./components/OrderDelete.vue').default);
Vue.component('signature-pad', require('./components/SignaturePad.vue').default);
Vue.component('fyc-cropper', require('./components/FycCropper.vue').default);
Vue.component('instructions', require('./components/Instructions.vue').default);
Vue.component('checkout-table', require('./components/CheckoutTable').default);
Vue.component('invoice-payment', require('./components/InvoicePayment').default);
Vue.component('admin-order-status-update', require('./components/AdminOrderStatusUpdate').default);
Vue.component('financials-table', require('./components/FinancialsTable').default);
Vue.component('orders-table', require('./components/OrdersTable').default);
Vue.component('admin-search', require('./components/AdminSearch').default);
Vue.component('question-popup', require('./components/QuestionPopup').default);
Vue.component('admin-unlock-order', require('./components/AdminUnlockOrder').default);
Vue.component('admin-change-user', require('./components/AdminChangeUser').default);
Vue.component('admin-internal-notes', require('./components/AdminInternalNotes').default);
Vue.component('video-component-upload', require('./components/VideoUploadComponent.vue').default);
Vue.component('orders-judging-table', require('./components/OrdersJudgingTable').default);
Vue.component('order-judging', require('./components/OrderJudging').default);
Vue.component('note-editor', require('./components/NoteEditor').default);
Vue.component('video-episode-viewer', require('./components/VideoEpisodeViewer').default);
Vue.component('entry-judging-details', require('./components/EntryJudgingDetails').default);
Vue.component('entry-judging-form-scored', require('./components/EntryJudgingFormScored').default);
Vue.component('judging-selections', require('./components/JudgingSelections').default);
Vue.component('clear-judge-groups', require('./components/ClearJudgeGroup').default);
Vue.component('phone-number-input', require('./components/PhoneNumberInput.vue').default);
Vue.component('password-input', require('./components/PasswordInput.vue').default);

// Auth Components
Vue.component('auth-verify-select-method', require('./components/Auth/AuthVerifySelectMethod.vue').default);
Vue.component('auth-verify-enter-code', require('./components/Auth/AuthVerifyEnterCode.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const generateRandomString = () => Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2);

const app = new Vue({
    el: '#app',
    data() {
        return {
            showLogout: false,
            showMessage: true,
            showmessageJudge: false,
            date_config: {dateFormat: 'm-d-Y'},
            alertShow: false,
            judge_num_selected: ''
        }
    },

    // Disable interpolation in the client side vue compiler to prevent XSS when outputting variables
    // server side using blade within the root component template (<div id=home>)
    // Vue provides no way to disable interpolation, so we set the delimiters to random strings.
    delimiters: [`{{${generateRandomString()}}}`, `{{${generateRandomString()}}}`],

    mounted () {
        if(document.querySelector('.judging-index-page') !== null) {
            if(window.innerHeight < (document.querySelector('.judging-index-page').clientHeight - 50)) {
                document.getElementById('continue-voting-long-page').style.display = 'block';
            }
        }
    },
    methods: {
        showFlashAlert: function() {
            this.alertShow = true;
        },
        showErrorAlert: function() {
            this.showmessageJudge = true;
        },
        updateNumJudgeSelections: function(numSelections) {
            if(numSelections < 0) {
                numSelections = 0;
            }
            this.judge_num_selected = numSelections;
        },
        clearImpersonate: function(ev) {
            localStorage.removeItem('honors-judge-grouping');
            localStorage.removeItem('honors-search-sort');
            localStorage.removeItem('honors-search-sort-order');
            localStorage.removeItem('honors-search-num');
            localStorage.removeItem('honors-search-page');
            window.location = $(ev.target).attr('href')
        }
    }
});

window.countWords = function(s){
    s = s.replace(/(^\s*)|(\s*$)/gi,"");//exclude  start and end white-space
    s = s.replace(/[ ]{2,}/gi," ");//2 or more space to 1
    s = s.replace(/\n /,"\n"); // exclude newline with a start spacing
    return s.split(' ').length;
}
